import React, { useCallback } from "react";
import { useQuery } from "react-query";
import ReactResizeDetector from "react-resize-detector";
import srv from "../../../../services";
import { ArrowLeftIcon, ArrowRightIcon } from "../../../_assests";
import { Spin, Slider, Item, Param } from "./Connections.styled";

interface Props {
  contractId?: number;
}

export default function Connections({ contractId }: Props) {
  const { data: connections, isLoading } = useQuery(
    ["connections", contractId],
    () => srv.getConnections(contractId)
  );

  const getSlidesCount = useCallback(
    (width: number) => {
      if (width > 1400 && connections?.length > 5) return 6;
      if (width > 900 && connections?.length > 4) return 5;
      if (width > 720 && connections?.length > 3) return 4;
      if (width > 600 && connections?.length > 2) return 3;
      if (width > 400 && connections?.length > 1) return 2;
      return 1;
    },
    [connections]
  );

  if (isLoading) return <Spin />;

  if (!connections?.length) return <>Нет подключений</>;

  return (
    <ReactResizeDetector handleWidth>
      {({ width }) => (
        <Slider
          infinite={false}
          dots
          speed={500}
          slidesToShow={getSlidesCount(width)}
          slidesToScroll={getSlidesCount(width)}
          noArrows={connections.length <= getSlidesCount(width)}
          prevArrow={<ArrowLeftIcon />}
          nextArrow={<ArrowRightIcon />}
        >
          {connections.map((connection) => (
            <div key={connection.id}>
              <Item>
                <Param>
                  <u>Объект</u> {connection.name}
                </Param>

                {!!connection.buildingState && (
                  <Param>
                    <u>Состояние</u> {connection.buildingState}
                  </Param>
                )}

                {!!connection.buildingType && (
                  <Param>
                    <u>Тип строения</u> {connection.buildingType}
                  </Param>
                )}

                {!!connection.address && (
                  <Param>
                    <u>Адрес</u> {connection.address}
                  </Param>
                )}
              </Item>
            </div>
          ))}
        </Slider>
      )}
    </ReactResizeDetector>
  );
}
